<template>
  <div class="run-schedule-directions">
    <run-schedule-collapse
      v-if="!hideScheduleCollapse"
      mode="schedule"
    />
    <component v-else :is="titleTag" class="text-center">
      {{ title }}
    </component>
    <run-schedule-direction
      title="Отправление"
      class="mt-60"
      is-dispatch
      :hideSelect="hideScheduleCollapse"
      :filial="dispatchFilial"
      :schedule="dispatchRows"
      @change-city="updateRows"
    />
    <run-schedule-direction
      title="Прибытие"
      class="mt-60"
      :hideSelect="hideScheduleCollapse"
      :filial="destinationFilial"
      :schedule="destinationRows"
      @change-city="updateRows"
    />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { getAddressByGuid, getSchedule } from '@/api/city'
import { Location } from '~/types/types'
import { declOfNum } from '~/common/functions'
import { useCityStore } from '~/stores/city'
import RunScheduleCollapse from '~/components/public/run-schedule/run-schedule-collapse.vue'
import RunScheduleDirection from '~~/components/public/run-schedule/run-schedule-direction.vue'

const { from, to } = storeToRefs(useCityStore())

type ScheduleFilial = {
  address: string
  schedule: any
}

const props = defineProps({
  date: {
    type: String,
    default: ''
  },
  hideScheduleCollapse: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Расписание межтерминальных рейсов'
  },
  titleH3: {
    type: Boolean,
    default: false
  }
})

const dispatchFilial = ref({} as Location)
const destinationFilial = ref({} as Location)
const dispatchRows = ref([] as ScheduleFilial[])
const destinationRows = ref([] as ScheduleFilial[])

const titleTag = computed(() => {
  return props.titleH3 ? 'h3' : 'h2'
})

watch(
    () => [from.value, to.value],
    updateRows,
    { immediate: true }
)

function updateRows(): void {
  nextTick(async () => {
    const data = await getSchedule({ dispatch: from.value.guid, destination: to.value.guid, date: props.date })

    await updateFilials()
    const fromCity = dispatchFilial.value?.name ? dispatchFilial.value : from.value
    const toCity = destinationFilial.value?.name ? destinationFilial.value : to.value

    dispatchRows.value = makeRow(data?.dispatch, `${fromCity?.type} ${fromCity?.name}`)
    destinationRows.value = makeRow(data?.destination, `${toCity?.type} ${toCity?.name}`)
  })
}

async function updateFilials() {
  if (Number(from.value.has_terminals) > 0) {
    dispatchFilial.value = {} as Location
  } else if(from.value.rcl_guid) {
    const { location } = await getAddressByGuid(from.value.rcl_guid)
    dispatchFilial.value = location
  }

  if (Number(to.value.has_terminals) > 0) {
    destinationFilial.value = {} as Location
  } else if(to.value.rcl_guid) {
    const { location } = await getAddressByGuid(to.value.rcl_guid)
    destinationFilial.value = location
  }
}

function makeRow(data: any[], city: string): ScheduleFilial[] {
  if (!data) {
    return []
  }

  const rows: ScheduleFilial[] = []
  const declDays = ['день', 'дня', 'дней']

  data.forEach((elem) => {
    const daysDict = Object.keys(elem.timetable)
    const schedule: any[] = []

    daysDict.map((day) => {
      const dayCount = elem.timetable[day].days

      schedule.push({
        title: `${elem.terminal.name} - ${day}`,
        time: elem.timetable[day].time,
        description: dayCount > 0 ? `в пути ${dayCount} ${declOfNum(dayCount, declDays)}` : '',
        active: elem.timetable[day].active
      })
      return elem.timetable[day]
    })

    rows.push({
      address: elem.terminal.name + ', ' + city,
      schedule
    })
  })
  return rows
}
</script>
